module.exports = __webpack_public_path__ + "media/toast-warning.e47c4294.mp3";